import {
  Squares2X2Icon,
  PresentationChartLineIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

/**
 * The Dashboards app-strip section: every member-facing analytics dashboard
 * in one place. Visibility is purely permission-driven per item — the
 * section (sidebar and app-strip icon) collapses on its own when none of
 * the children survive filtering.
 *
 * Total Addressable Market deliberately appears BOTH here and in Lead
 * Generation: stage members reach it here without seeing Lead Generation,
 * while existing lead-gen customers keep finding it where it has always
 * been. Same page component, two routes.
 */
const navigation: NavigationItem[] = [
  {
    name: "Sales and Customer Dashboard",
    href: "/dashboards/sales-and-customer-dashboard",
    icon: Squares2X2Icon,
    current: false,
    internalName: "dashboards_sales_customer",
    permissions: ["stochastic-dashboard"],
  },
  {
    name: "Member Dashboard",
    href: "/dashboards/member-dashboard",
    icon: PresentationChartLineIcon,
    current: false,
    internalName: "dashboards_member",
    permissions: ["member-dashboard"],
  },
  {
    name: "Total Addressable Market",
    href: "/dashboards/total-addressable-market",
    icon: ChartBarIcon,
    current: false,
    internalName: "dashboards_total_addressable_market",
    permissions: ["stochastic-total-addressable-market"],
  },
];

const dashboardsConfig = {
  sectionName: "dashboards",
  defaultRoute: "/dashboards/sales-and-customer-dashboard",
  navigation,
};

export default dashboardsConfig;
